<template>
    <b-card :header="caption" header-class="text-left" class="text-center">
        <p v-if="loadStatus == 3" class="text-center mb-0">Data load error</p>
        <div v-else id="master-table">
            <b-modal id="edit-form-modal" modal-class="text-center" centered :title="isEdit ? 'Edit user' : 'Create user'" @ok="processItem" @show="resetModalIfCreate" ref="edit-form-modal" :key="editFormModal">
                <loading :active="internalSubmitStatus == 1"></loading>
                <div>
                    <div class="invalid-feedback d-block" v-if="message">
                        {{ message }}
                    </div>
                    <b-form-group>
                        <b-input-group v-if="isEdit">
                            <b-input-group-prepend is-text class="item-header-text">
                                ID
                            </b-input-group-prepend>
                            <b-form-input type="number" placeholder="ID" :disabled="true" :value="processingItem.id"/>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group>
                        <b-input-group>
                            <b-input-group-prepend is-text class="item-header-text">
                                <span>Email</span>
                            </b-input-group-prepend>
                            <b-form-input type="email" placeholder="youremail@something.com" :disabled="true" :value="processingItem.email" v-if="isEdit"/>
                            <b-form-input type="email" placeholder="youremail@something.com" v-on:input="$v.form.email.$touch()" :state="$v.form.email.$dirty ? !$v.form.email.$error : null" v-model="form.email" v-else/>
                        </b-input-group>
                        <div class="row">
                            <div class="col-3 d-block">
                            </div>
                            <div class="col-9 invalid-feedback text-left d-block" v-if="$v.form.email.$invalid && validation && validation.email">
                                {{ validation.email[0] }}
                            </div>
                        </div>
                    </b-form-group>
                    <b-form-group v-if="!isEdit">
                        <b-input-group>
                            <b-input-group-prepend is-text class="item-header-text">
                                <span>Password</span>
                            </b-input-group-prepend>
                            <b-form-input type="password" placeholder="********" v-on:input="$v.form.password.$touch()" :state="$v.form.password.$dirty ? !$v.form.password.$error : null" v-model="form.password"/>
                        </b-input-group>
                        <div class="row">
                            <div class="col-3 d-block">
                            </div>
                            <div class="col-9 invalid-feedback text-left d-block" v-if="$v.form.password.$invalid && validation && validation.password">
                                {{ validation.password[0] }}
                            </div>
                        </div>
                    </b-form-group>
                    <b-form-group>
                        <b-input-group>
                            <b-input-group-prepend is-text class="item-header-text">
                                <span>Verified at</span>
                            </b-input-group-prepend>
                            <b-datepicker v-model="form.email_verified_at" placeholder="08 Aug 2019" v-if="isEdit"/>
                            <b-datepicker v-model="form.email_verified_at" :state="$v.form.email_verified_at | state" placeholder="08 Aug 2019" v-else/>
                        </b-input-group>
                        <div class="row">
                            <div class="col-3 d-block">
                            </div>
                            <div class="col-9 invalid-feedback text-left d-block" v-if="$v.form.email_verified_at.$invalid && validation && validation.email_verified_at">
                                {{ validation.email_verified_at[0] }}
                            </div>
                        </div>
                    </b-form-group>
                    <b-form-group
                    :label-cols="3"
                    label="Roles"
                    label-for="basicCustomCheckboxes"
                    >
                        <b-form-checkbox-group id="roles-checkboxes" stacked>
                            <div class="text-left custom-control custom-checkbox">
                                <input
                                  id="role-1-checkbox"
                                  type="checkbox"
                                  class="custom-control-input"
                                  value="1"
                                  :checked="processingItem.roleIdArr ? processingItem.roleIdArr.includes(1) : false"
                                  @change="setRole1Checkbox($event.target.value)"
                                >
                                <label class="custom-control-label" for="role-1-checkbox">
                                  Member
                                </label>
                              </div>
                              <div class="text-left custom-control custom-checkbox">
                                <input
                                    id="role-2-checkbox"
                                    type="checkbox"
                                    class="custom-control-input"
                                    value="2"
                                    :checked="processingItem.roleIdArr ? processingItem.roleIdArr.includes(2) : false"
                                    @change="setRole2Checkbox($event.target.value)"
                                >
                                <label class="custom-control-label" for="role-2-checkbox">
                                  Moderator
                                </label>
                              </div>
                              <div class="text-left custom-control custom-checkbox">
                                  <input
                                      id="role-3-checkbox"
                                      type="checkbox"
                                      class="custom-control-input"
                                      value="3"
                                      :checked="processingItem.roleIdArr ? processingItem.roleIdArr.includes(3) : false"
                                      @change="setRole3Checkbox($event.target.value)"
                                  >
                                <label class="custom-control-label" for="role-3-checkbox">
                                  Administrator
                                </label>
                              </div>
                          </b-form-checkbox-group>
                          <div class="invalid-feedback d-block text-left col-9" v-if="$v.form.role1.$invalid && $v.form.role2.$invalid && $v.form.role3.$invalid">
                              {{ "Please select at least one role." }}
                          </div>
                      </b-form-group>
                  </div>
            </b-modal>
            <div class="row justify-content-between">
                <div class="col-2 pl-0 pr-0 mb-3 mt-2">
                    <b-input-group class="input-group-sm">
                      <b-form-select
                        @input="onChangePerPage"
                        v-model="perPage"
                        id="per_page"
                        :plain="false"
                        :options="[{ text: '15', value: 15}, { text: '30', value: 30}, { text: '50', value: 50}]"
                        size="xs"
                        value="Please select"
                        class="col-12"
                      />
                    </b-input-group>
                </div>
                <div class="col-8 text-right mb-3 mt-2 pr-0 pl-2">
                    <b-button size="sm" class="btn-action" variant="danger" @click="deleteItems()" v-if="hasChecked">
                        <i class="fa fa-remove text-white" aria-hidden="true"></i> <span class="text-white">Delete</span>
                    </b-button>
                    <b-button size="sm" class="btn-action" variant="primary" @click="prepareCreatingItem()" v-b-modal.edit-form-modal>
                        <i class="fa fa-file text-white" aria-hidden="true"></i> <span class="text-white">Create</span>
                    </b-button>
                </div>
            </div>

            <b-table
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            :items="tableData.data"
            :fields="fields"
            :current-page="currentPage"
            per-page=0
            responsive="sm"
            show-empty
            :empty-text="emptyText"
            :busy="loadStatus == 1"
            >
                <div slot="table-busy" class="text-center text-info my-2">
                    <b-spinner class="align-middle"></b-spinner>
                </div>
                <template slot="checkbox" slot-scope="row">
                    <b-form-checkbox
                      :id="'checkbox-item-' + row.item.id"
                      :name="'checkbox-item-' + row.item.id"
                      :data-id="row.item.id"
                      class="checkbox-item"
                      @input="selectItem(row.item)"
                      value="checked"
                      unchecked-value="unchecked"
                    >
                    </b-form-checkbox>
                </template>
                <template slot="status" slot-scope="row" v-if="tableData.data.length > 0">
                    <b-badge :variant="getBadge(row.item.status)">
                        {{ row.item.status }}
                    </b-badge>
                </template>
                <template slot="created_at" slot-scope="row" v-if="tableData.data.length > 0">
                    {{ row.item.created_at.slice(0, -8) }}
                </template>
                <template slot="actions" slot-scope="row">
                    <b-button size="sm" class="btn-action mt-1 mb-1" variant="warning" @click="prepareEditingItem(row.item)" v-b-modal.edit-form-modal>
                        <i class="fa fa-pencil text-white" aria-hidden="true"></i> <span class="text-white">Edit</span>
                    </b-button>
                    <b-button size="sm" class="btn-action mt-1 mb-1" variant="danger" @click="deleteItem(row.item)">
                        <i class="fa fa-trash text-white" aria-hidden="true"></i> <span class="text-white">Delete</span>
                    </b-button>
                    <b-button size="sm" class="btn-action mt-1 mb-1" variant="success" @click="unbanItem(row.item)" v-if="row.item.status == 'Banned'">
                        <i class="fa fa-unlock text-white" aria-hidden="true"></i> <span class="text-white">Unban</span>
                    </b-button>
                    <b-button size="sm" class="btn-action mt-1 mb-1" variant="danger" @click="banItem(row.item)" v-if="row.item.status != 'Banned'">
                        <i class="fa fa-lock text-white" aria-hidden="true"></i> <span class="text-white">Ban</span>
                    </b-button>
                </template>
            </b-table>
            <p v-if="loadStatus == 3" class="text-center mb-0">Data load error</p>
            <nav v-if="loadStatus == 2">
                <b-pagination
                v-model="currentPage"
                :total-rows="tableData.total"
                :per-page="tableData.per_page"
                class="mb-2"
                size="sm"
                >
                </b-pagination>
            </nav>
        </div>
    </b-card>
</template>

<script>
import { sameAs, required, email } from 'validators'
import AdminTableUtils from './../../../../mixins/admin-table-utils'

export default {
    name : 'cTable',
    mixins: [AdminTableUtils],
    props: {
        caption: {
            type: String,
            default: 'Table',
        },
        hover: {
            type: Boolean,
            default: false,
        },
        striped: {
            type: Boolean,
            default: false,
        },
        bordered: {
            type: Boolean,
            default: false,
        },
        small: {
            type: Boolean,
            default: false,
        },
        fixed: {
            type: Boolean,
            default: false,
        },
        tableData: {
            type: Object,
            default: {},
        },
        fields: {
            type: Array,
            default: [],
        },
        loadStatus: {
            type: Number,
            default: 0
        },
        submitStatus: {
            type: Number,
            default: 2
        },
        message: {
            type: String,
            default: '',
        },
        validation: {
            type: Object,
            default: null
        },
        emptyText: {
            type: String,
            default: 'There are no records to show'
        },
    },
    validations () {
        return {
            form: {
                role1: { sameAs: sameAs( () => true ) },
                role2: { sameAs: sameAs( () => true ) },
                role3: { sameAs: sameAs( () => true ) },
                email: { required, email },
                email_verified_at: {},
                password: { required },
            },
        }
    },
    data: () => {
        return {
            currentPage: 1,
            perPage: window.localStorage.getItem('per_page') || 15,
            hasChecked: false,
            isEdit: false,
            processingItem: {},
            form: {
                role1: '',
                role2: '',
                role3: '',
                email: '',
                email_verified_at: null,
                password: ''
            },
            editFormModal: 0,
            internalSubmitStatus: 2
        }
    },
    methods: {
        resetModalIfCreate(bvModalEvt) {
            this.$v.$reset()
            if (this.isEdit) {
                return;
            }

            this.form = {
                role1: false,
                role2: false,
                role3: false,
                email: '',
                email_verified_at: null,
                password: ''
            }
            this.$emit('reset_validation')
            this.processingItem = {}
            // Uncheck role checkboxes
            if (document.getElementById('role-1-checkbox') && document.getElementById('role-2-checkbox') && document.getElementById('role-3-checkbox'))
            {
                document.getElementById('role-1-checkbox').checked = false
                document.getElementById('role-2-checkbox').checked = false
                document.getElementById('role-3-checkbox').checked = false
            }
        },
        setRole1Checkbox(value) {
            this.form.role1 = $('#role-1-checkbox').prop("checked")
            this.$v.form.role1.$touch()
        },
        setRole2Checkbox(value) {
            this.form.role2 = $('#role-2-checkbox').prop("checked")
            this.$v.form.role2.$touch()
        },
        setRole3Checkbox(value) {
            this.form.role3 = $('#role-3-checkbox').prop("checked")
            this.$v.form.role3.$touch()
        },
        selectItem (item) {
            this.computeHasChecked()
        },
        prepareCreatingItem () {
            // Let modal know this is create action
            this.isEdit = false;
            this.internalSubmitStatus = 2
        },
        prepareEditingItem (item) {
            // Let modal know this is edit action
            this.isEdit = true;
            this.internalSubmitStatus = 2
            this.forceRerender()
            this.processingItem = item
            this.processingItem.roleIdArr = item.roles.map(role => role.id)
            this.form.email = this.processingItem.email
            this.form.role1 = this.processingItem.roleIdArr.includes(1)
            this.form.role2 = this.processingItem.roleIdArr.includes(2)
            this.form.role3 = this.processingItem.roleIdArr.includes(3)
            this.form.email_verified_at = this.processingItem.email_verified_at
        },
        processItem (bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault()

            // Decide which logic to do
            if (this.isEdit) {
                this.editItem();
            } else {
                this.createItem();
            }
        },
        createItem () {
            var vm = this
            // Check for data validity
            this.$v.$touch()

            // Prepare data
            let roleIdsSeq = ''
            if ($('#role-1-checkbox').prop("checked")){
                roleIdsSeq += '1,'
            }
            if ($('#role-2-checkbox').prop("checked")){
                roleIdsSeq += '2,'
            }
            if ($('#role-3-checkbox').prop("checked")){
                roleIdsSeq += '3,'
            }

            vm.processingItem.role_ids = roleIdsSeq
            vm.processingItem.roleIdArr = vm.processingItem.role_ids.split(",");
            vm.processingItem.email = vm.form.email
            vm.processingItem.email_verified_at = vm.form.email_verified_at
            vm.processingItem.password = vm.form.password

            // Broadcast edit_item event
            vm.$emit('create_item', vm.processingItem, this.currentPage, this.perPage)
        },
        editItem () {
            var vm = this
            // Prepare data
            let roleIdsSeq = ''
            if ($('#role-1-checkbox').prop("checked")){
                roleIdsSeq += '1,'
            }
            if ($('#role-2-checkbox').prop("checked")){
                roleIdsSeq += '2,'
            }
            if ($('#role-3-checkbox').prop("checked")){
                roleIdsSeq += '3,'
            }
            vm.processingItem.role_ids = roleIdsSeq
            vm.processingItem.email_verified_at = this.form.email_verified_at

            // Broadcast edit_item event
            vm.$emit('edit_item', vm.processingItem, this.currentPage, this.perPage)
        },
        deleteItem (item) {
            var vm = this
            this.$swal({
                title: 'You sure to delete this item?',
                text: "This is a soft delete mechanism. After deleting, data will no longer show here but still be remained in DB.",
                type: 'warning',
                showCancelButton: true,
                reverseButtons: true,
                confirmButtonColor: '#f86c6b',
                cancelButtonColor: '#a4b7c1',
                confirmButtonText: 'Delete'
            }).then((result) => {
                if (result.value) {
                    vm.$emit('delete_item', item.id, this.currentPage, this.perPage)
                }
            })
        },
        deleteItems () {
            var vm = this
            this.$swal({
                title: 'You sure to delete these items?',
                text: "This is a soft delete mechanism. After deleting, data will no longer show here but still be remained in DB.",
                type: 'warning',
                showCancelButton: true,
                reverseButtons: true,
                confirmButtonColor: '#f86c6b',
                cancelButtonColor: '#a4b7c1',
                confirmButtonText: 'Delete'
            }).then((result) => {
                if (result.value) {
                    // Gather items' ids
                    var itemIds = [];
                    $('table .checkbox-item input').filter(':checked').each(function (index) {
                        let id = $(this).data('id');
                        itemIds.push(id)
                    })
                    let itemIdsSeq = itemIds.join(',')

                    vm.$emit('delete_items', itemIdsSeq, this.currentPage, this.perPage)
                }
            })

        },
        banItem (item) {
            var vm = this
            this.$swal({
                title: 'You sure to ban this user?',
                text: "Banned users will not be able to login until you unban them.",
                type: 'warning',
                showCancelButton: true,
                reverseButtons: true,
                confirmButtonColor: '#f86c6b',
                cancelButtonColor: '#a4b7c1',
                confirmButtonText: 'Yes, ban him/her!'
            }).then((result) => {
                if (result.value) {
                    vm.$emit('ban_item', item.id, this.currentPage, this.perPage)
                }
            })
        },
        unbanItem (item) {
            var vm = this
            this.$swal({
                title: 'You sure to unban this user?',
                text: "This user will be able to login again after being unbanned.",
                type: 'info',
                showCancelButton: true,
                reverseButtons: true,
                confirmButtonColor: '#4dbd74',
                cancelButtonColor: '#a4b7c1',
                confirmButtonText: 'Yes, unban him/her.'
            }).then((result) => {
                if (result.value) {
                    vm.$emit('unban_item', item.id, this.currentPage, this.perPage)
                }
            })
        },
        getBadge (status) {
            return status === 'Activated' ? 'success'
            : status === 'Unactivated' ? 'secondary'
            : status === 'Banned' ? 'danger' : 'primary'
        },
        onChangePerPage (newPerPage) {
            // Remember user's preference for per_page
            window.localStorage.setItem('per_page', newPerPage)
        },
        forceRerender() {
            this.editFormModal += 1;
        }
    },
    watch: {
        currentPage: function (newVal, oldVal) {
            // Request to change data, but not on the first load
            if (oldVal) {
                this.$emit('page_changed', newVal, this.perPage)
            }
        },
        perPage: function (newVal, oldVal) {
            // Request to change data, but not on the first load
            if (oldVal) {
                this.$emit('per_page_changed', newVal)
            }
        },
        isToCloseModal: function (newVal, oldVal) {
            // Request to change data, but not on the first load
            if (newVal == 2) {
                this.$refs["edit-form-modal"].hide()
            }
        },
        submitStatus(newVal) {
           this.internalSubmitStatus = newVal
        }
    },
    computed: {
        isToCloseModal: {
            get()
            {
                return this.internalSubmitStatus
            },
            set(value)
            {
                this.internalSubmitStatus = value
            }
        }
    }
}
</script>
